import { jsx as t } from "react/jsx-runtime";
import "../../layout/Stack/Stack.js";
import p from "../../layout/Box/Box.js";
import "styled-components";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import e from "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
function j(o) {
  const { htmlFor: r, children: i, dataTest: m } = o;
  return /* @__PURE__ */ t(p, { component: "label", htmlFor: r, dataTest: m, children: /* @__PURE__ */ t(e, { size: "xsmall", tone: "neutral", weight: "bold", children: i }) });
}
export {
  j as default
};
